<template>
  <div class="lottery-header">
    <div class="inner">
      <h1 class="title">
        <span class="title-inner"
          ><em class="title-em">SAUNA FINANCE</em>Game Center<img
            src="/assets/sf/image/dice.png"
            class="title-icon"
        /></span>
      </h1>

      <p class="lead">
        <span class="lead-inner"
          >Lottery and Game content provided by SAUNA FINANCE, which you can
          <br />
          participate in with BNB, BUSD and SAUNA.</span
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LotteryHeader",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.lottery-header {
  background-color: var(--color_bg_parts);
  overflow: hidden;

  .inner {
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;

    &::after {
      content: "";
      background-image: url(/assets/sf/image/bg_lottery.png);
      background-repeat: no-repeat;
      background-size: contain;
      display: block;
    }
  }
  @include media(pc) {
    padding: 0 80px;

    .inner {
      width: 1100px;
      height: 350px;

      &::after {
        position: absolute;
        right: -50px;
        bottom: 60px;
        width: 247px;
        height: 240px;
      }
    }
  }
  @include media(sp) {
    padding: 56px 40px 24px;

    .inner {
      &::after {
        margin: auto;
        width: 60vw;
        height: 0;
        padding-top: 58%;
        background-position: center;
      }
    }
  }
}
.title {
  font-weight: 800;
  margin-bottom: 24px;

  @include media(pc) {
    font-size: 3.5rem;
  }
  @include media(sp) {
    font-size: 2.2rem;
  }
}
.title-inner {
  display: inline-block;
  background: $gradation-vertical-reverse;
  background-clip: text;
  color: transparent;
  line-height: 1.5;
}
.title-em {
  margin-right: 0.2em;

  @include media(pc) {
    font-size: 5.5rem;
  }
  @include media(sp) {
    display: block;
    font-size: 3.1rem;
  }
}
.title-icon {
  vertical-align: middle;

  @include media(pc) {
    width: 55px;
    margin: -0.2em 24px 0 24px;
  }
  @include media(sp) {
    width: 32px;
    margin: -0.2em 16px 0 16px;
  }
}
.lead-inner {
  display: inline-block;
  background: $gradation-vertical-reverse;
  background-clip: text;
  color: transparent;
  font-weight: 400;

  @include media(pc) {
    font-size: 2rem;
  }
  @include media(sp) {
    font-size: 1rem;
    margin-bottom: 40px;
  }
}
</style>